import LinkToDocusaurus from '../LinkToDocusaurus'
import { bugHuntingHeatmap } from '../../docs-routes'

const LinkToBugHuntingHeatmapDoc = () =>
  <LinkToDocusaurus path={bugHuntingHeatmap}>
    Learn more about Bug Hunting Heatmap
  </LinkToDocusaurus>

export default LinkToBugHuntingHeatmapDoc
